import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { DateFnsAdapter } from "@angular/material-date-fns-adapter";
import { getYear } from "date-fns";
import { enUS } from "date-fns/locale";
import { ITags } from "../../features/bucket-items/models/bucket-item.model";
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon } from "@angular/material/datepicker";
import { IDynamicControlModel } from "../../dynamic-controls/dynamic-control-model";
import { MatFormField, MatInput, MatSuffix } from "@angular/material/input";

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: "yyyy",
  },
  display: {
    dateInput: "yyyy",
    monthYearLabel: "MMM yyyy",
    dateA11yLabel: "PP",
    monthYearA11yLabel: "MMMM yyyy",
  },
};

@Component({
    selector: "app-year-picker",
    templateUrl: "./year-picker.component.html",
    styleUrls: ["./year-picker.component.scss"],
    providers: [
        {
            provide: DateAdapter,
            useClass: DateFnsAdapter,
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: enUS,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: YEAR_MODE_FORMATS,
        },
    ],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepickerToggleIcon, MatDatepicker]
})
export class YearPickerComponent implements OnInit {
  @Input() parent: any;
  @Input() public tag: IDynamicControlModel;
  @Input() public placeHolder: string;
  @Output() public selectedValue: EventEmitter<Partial<ITags>> =
    new EventEmitter<Partial<ITags>>();

  public dateControlForm: FormGroup = new FormGroup({
    yearControl: new FormControl(""),
  });
  currentYear: number = new Date().getFullYear();
  ngOnInit(): void {
    this.initForm();
    this.dateControlForm
      .get("yearControl")
      .valueChanges.subscribe((year: number) => {
        this.selectedValue.emit({
          TagKey: this.tag.TagKey,
          TagValue: year.toString(),
          TagsDisplayOrder: this.tag.TagsDisplayOrder,
        });
      });
  }

  setParent(parent: any) {
    this.parent = parent;
  }
 

  initForm(): void {
    this.dateControlForm.get("yearControl").patchValue("");
  }

  calenderSelected(
    normalizedYear: Date,
    picker: MatDatepicker<Date>
  ): void {
    this.dateControlForm
      .get("yearControl")
      .setValue(getYear(normalizedYear).toString());
    picker.close();
  }

  public clearContent(): void {
    this.dateControlForm.get("yearControl").patchValue("");
  }

  disableFutureDate = (d: Date | null) => {
    const year = getYear(d || new Date());
    return year >= 1000 && year <= this.currentYear;
  };

  viewChanged(picker: MatDatepicker<Date>) {
    picker.close();
  }

  public buildYearPickerId(controlId: string): string {
    return `year-picker-${controlId}`;
  }
}
